import React from "react";
import VelkieLayout from "../VelkieLayout";

const CurrentBet = () => {
  return (
    <VelkieLayout>
      <div className="pb-20 relative" data-v-58b8c71f="">
        <div
          className="mb-20"
          data-v-732d8950=""
          style={{
            "--1344c9d1": "57px",
            "--914528c2": "translateX(7px)",
          }}
        >
          <header
            className="h-12 p-3 bg-secondary text-global-font-on-dark text-14 flex items-center justify-center"
            data-v-732d8950=""
          >
            Current Bets
            <div className="icon-close text-16 absolute right-4" />
          </header>
          <section
            className="tab-wrapper relative bg-black-300 overflow-x-scroll"
            data-v-732d8950=""
          >
            <div
              className="h-full inline-block"
              data-v-732d8950=""
              style={{
                transform: "translateX(0px) translateY(0px) translateZ(1px)",
                transitionDuration: "0ms",
                transitionProperty: "transform",
                transitionTimingFunction: "cubic-bezier(0.165, 0.84, 0.44, 1)",
              }}
            >
              <ul
                className="ml-2 mr-1 w-full h-12 flex flex-nowrap justify-start items-center"
                data-v-732d8950=""
                style={{
                  pointerEvents: "auto",
                }}
              >
                <li
                  className="text-13 font-bold py-2 mr-6 text-center whitespace-nowrap"
                  data-v-732d8950=""
                >
                  Exchange
                </li>
                <li
                  className="text-13 font-bold py-2 mr-6 text-center whitespace-nowrap"
                  data-v-732d8950=""
                  value="3"
                >
                  Bookmaker
                </li>
                <li
                  className="text-13 font-bold py-2 mr-6 text-center whitespace-nowrap"
                  data-v-732d8950=""
                  value="7"
                >
                  Fancybet
                </li>
                <li
                  className="text-13 font-bold py-2 mr-6 text-center whitespace-nowrap"
                  data-v-732d8950=""
                  value="2"
                >
                  Sportsbook
                </li>
                <li
                  className="text-13 font-bold py-2 mr-6 text-center whitespace-nowrap"
                  data-v-732d8950=""
                  value="8"
                >
                  Parlay
                </li>
                <div
                  className="tab-indicator absolute left-0 bottom-1.5 bg-global-font-on-light rounded-full"
                  data-v-732d8950=""
                />
              </ul>
            </div>
          </section>

          <div className="content px-4 py-4" data-v-732d8950="">
            <div data-v-732d8950="" />
            <div
              className="flex justify-center items-center py-48"
              data-v-732d8950=""
              style={{}}
            >
              <div className="pt-6 px-7 pb-5 bg-white text-center text-black-700 text-base rounded-xl leading-tight">
                <div
                  alt=""
                  className="icon-empty text-40 text-black-300 m-auto mb-2.5"
                />
                <div>No Data</div>
              </div>
            </div>
          </div>
          <div
            className="bg-black-100 p-14px mt-auto fixed bottom-0 w-full"
            data-v-732d8950=""
            style={{
              display: "none",
            }}
          >
            <button className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed bg-error text-global-font-on-dark w-full rounded-4px">
              <i className="icon-del text-14 mr-3px" /> Cancel{" "}
            </button>
          </div>
        </div>
      </div>
    </VelkieLayout>
  );
};

export default CurrentBet;
